import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { InnerPageLayoutComponent } from 'src/app/components/layouts/inner-page-layout/inner-page-layout.component';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { ReportsService } from 'src/app/services/reports.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-vendor-dashboard',
  templateUrl: './vendor-dashboard.component.html',
  styleUrls: ['./vendor-dashboard.component.scss']
})
export class VendorDashboardComponent implements OnInit {

  @ViewChild('divClick') divClick: ElementRef;
  @ViewChild('miDrillDownData') miDrillDownData: ElementRef;
  @ViewChild('pondDrillDownData') pondDrillDownData: ElementRef;
  @ViewChild('miDistrictWiseDataCard') miDistrictWiseDataCard: ElementRef;

  public pieChartData: any = [];
  public options: any;
  public options1: any;
  public options2: any;
  public optionsLine: any;
  public optionsMIDW: any;
  public optionsSubsidy: any;
  public optionsCaste: any;
  public optionsAppType: any;
  public optionsComponent: any;


  public miData: any;
  public miBifurcatedData: any;
  
  public pondData: any;
  public pondBifurcatedData: any;
  
  public miDistrictWiseData: any;
  public miDistrictWiseDataForChart: any;

  public miDistrictWiseDashboardData: any;

  // public subsidyData: any;
  public subsidyDataForChart: any;
  
  public subsidyAreaDataForChart: any;
  public subsidyAmountDataForChart: any;

  // public casteData: any;
  public casteDataForChart: any;

  // public appTypeData: any;
  public appTypeDataForChart: any;

  // public componentData: any;
  public componentDataForChart: any;

  // public yearWiseData: any;
  public yearWiseDataForChart: any;

  public showMIUnderProcessDetails: boolean = false;
  public showMICompletedDetails: boolean = false;
  public showMIRejectedDetails: boolean = false;
  public showMIIncompletedDetails: boolean = false;
  public showMITotalDDDetails: boolean = false;
  public showMITotalDetails: boolean = false;

  public showPondUnderProcessDetails: boolean = false;

  public pieChartOptions: any = {}

  public districtWiseHeader = `All districts details`;

  public userId: any;

  public totalSubsidyDisbursed: number = 0;
  public totalAppCompleted: number = 0;
  public totalMIAreaCompleted: number = 0;

  // private targetTotalSubsidyDisbursed = 0;
  // private targetTotalAppCompleted = 0;
  // private targetTotalMIAreaCompleted = 0;
  userType:any
  public showMIDistrciData: boolean = false;
  vendorCode:any

  public selectedYearForData: any = '';

  constructor(
    public appMain: InnerPageLayoutComponent,
    private reportsService: ReportsService,
    private messageService: MessageService,
    private loader: AppLoaderService,
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { 
    Chart.register(ChartDataLabels);
  }

  ngOnInit(): void {
    this.selectedYearForData = '';
    setTimeout(() => {
      this.divClick.nativeElement.click();
    }, 200);

    this.animateCounter('totalSubsidyDisbursed', this.totalSubsidyDisbursed);
    this.animateCounter('totalAppCompleted', this.totalAppCompleted);
    this.animateCounter('totalMIAreaCompleted', this.totalMIAreaCompleted);

    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = (JSON.parse(payload)?.sub).toLowerCase();
    this.vendorCode=JSON.parse(sessionToken).officeCode
    // this.userIdUpperCase = JSON.parse(payload)?.sub
    this.userType = JSON.parse(sessionToken).role;


    this.loadMIData()
    this.loadPondData()
    if(this.userType=='Vendor'){
      this.loadMIDistrictWiseData();
      this.loadMIDistrictWiseDashboardData('');
      this.showMIDistrciData = true;
      this.districtWiseHeader = `All districts details`
    }
  }
  private animateCounter(property: string, endValue: number): void {
    const duration = 2000; // Duration of the animation in milliseconds
    const frameRate = 60; // Number of updates per second
    const totalFrames = (duration / 1000) * frameRate;
    let frame = 0;

    const intervalId = setInterval(() => {
      frame++;
      const progress = frame / totalFrames;
      const currentCount = Math.floor(progress * endValue);

      this[property] = currentCount;

      if (frame >= totalFrames) {
        clearInterval(intervalId);
        this[property] = endValue; // Ensure the final value is set
      }
    }, 1000 / frameRate);
  }

  loadMIData() {
    this.loader.start();
    let sub = this.reportsService
      .getMIAggregateTabsDataNewVendor(this.selectedYearForData, this.userType, this.vendorCode)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.miData = data[0];
            this.loadPieChartData();
            this.loadMIBifurcatedData();

            //save data in session storage
            // if (finYear == '') {
            //   window.sessionStorage.setItem('MIDataAll', JSON.stringify(data));
            // }
            // else if (finYear == '2022-23') {
            //   window.sessionStorage.setItem('MIData2223', JSON.stringify(data));
            // }
            // else if (finYear == '2023-24') {
            //   window.sessionStorage.setItem('MIData2324', JSON.stringify(data));
            // }

          } else {
            this.miData = [];
            this.loadPieChartData();
            this.loadMIBifurcatedData();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.miData = [];

          this.loadPieChartData();
          this.loadMIBifurcatedData();

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadPondData() {
    this.loader.start();
    let sub = this.reportsService
      .getPondAggregateTabsDataNew(this.selectedYearForData)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.pondData = data[0];
            this.loadPieChartData();
            this.loadPondBifurcatedData();

            // //save data in session storage
            // if (finYear == '') {
            //   window.sessionStorage.setItem('MIDataAll', JSON.stringify(data));
            // }
            // else if (finYear == '2022-23') {
            //   window.sessionStorage.setItem('MIData2223', JSON.stringify(data));
            // }
            // else if (finYear == '2023-24') {
            //   window.sessionStorage.setItem('MIData2324', JSON.stringify(data));
            // }

          } else {
            this.pondData = [];
            this.loadPieChartData();
            this.loadPondBifurcatedData();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.pondData = [];

          this.loadPieChartData();
          this.loadPondBifurcatedData();

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadPieChartData1() {

    let miTotalCount = this.miData ? (this.miData?.totalApp ? this.miData?.totalApp : 0) : 0;
    let pondTotalCount = this.pondData ? (this.pondData?.totalApp ? this.pondData?.totalApp : 0) : 0;


    this.pieChartOptions = {
      animationEnabled: true,
      theme: "dark2",
      colorSet: "customColorSet",
      title: {
        text: "Total Applications"
      },
      data: [{
        type: "doughnut",
        indexLabel: "{name}: {y}",
        innerRadius: "90%",
        yValueFormatString: "#,##0.00",
        dataPoints: [
          { y: miTotalCount, name: `MI(PDMC)` },
          { y: pondTotalCount, name: `Pond/Tank` },
        ]
      }]
    }
  }

  loadPieChartData() {
    // let labels = [];
    // let areaData = [];
    // let backgroundColors = [];
    // for (let index = 0; index < this.districtWiseData.length; index++) {
    //     labels.push(this.districtWiseData[index].District)
    //     areaData.push(this.districtWiseData[index].totalApp)
    //     const randomColor = "#" + ((1 << 24) * Math.random() | 0).toString(16);
    //     backgroundColors.push(randomColor)
    // }
    // this.pieChartData.labels = labels;
    // this.pieChartData.datasets[0].data = areaData;
    // this.pieChartData.datasets[0].backgroundColor = backgroundColors;
    // this.pieChartRef.reinit();


    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    let miTotalCount = this.miData ? (this.miData?.totalApp ? this.miData?.totalApp : 0) : 0;
    let pondTotalCount = this.pondData ? (this.pondData?.totalApp ? this.pondData?.totalApp : 0) : 0;


    // this.pieChartData = {
    //   labels: [`MI(PDMC): (${miTotalCount}) `, `Pond/Tank: (${pondTotalCount})`],
    //   datasets: [
    //     {
    //       data: [miTotalCount, pondTotalCount],
    //       backgroundColor: [
    //         // documentStyle.getPropertyValue('--green-500'),
    //         // documentStyle.getPropertyValue('--bluegray-500'),
    //         'rgb(51, 153, 102)',
    //         'rgb(0, 102, 204)',
    //       ],
    //       hoverBackgroundColor: [
    //         // documentStyle.getPropertyValue('--green-400'),
    //         // documentStyle.getPropertyValue('--bluegray-500'),
    //         'rgb(51, 153, 102)',
    //         'rgb(0, 102, 204)',
    //       ],
    //       borderWidth: 2
    //     },
    //   ],
    // };

    this.options = {
      plugins: {
        datalabels: {
          anchor: 'center',
          align: 'end',
          color: '#FFFFFF',
          offset: -7,
          font: {
            weight: 'bold',
            size: 8 
          },
        },
        legend: {
          labels: {
            usePointStyle: true,
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
        },
      },
    };
  }

  loadMIBifurcatedData() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.miBifurcatedData = {
      // labels: [`MI(PDMC) Applications: (${miTotalCount}) `, `Pond/Tank Applications: (${pondTotalCount})`],
      labels: ['Completed', 'Under Process', 'Rejected', 'Incomplete'],
      datasets: [
        {
          data: [this.miData?.CompletedApps, this.miData?.UnProcessedApps, this.miData?.rejectedApp, this.miData?.InCompleteApps],
          backgroundColor: [
            // documentStyle.getPropertyValue('--green-600'),
            // documentStyle.getPropertyValue('--yellow-600'),
            '#2eb82e',
            '#e6e600',
            '#ff0000',
            '#ff9900',
            // documentStyle.getPropertyValue('--blue-500')
            // documentStyle.getPropertyValue('--pink-500'),
          ],
          hoverBackgroundColor: [
            // documentStyle.getPropertyValue('--green-500'),
            // documentStyle.getPropertyValue('--yellow-500'),
            '#5cd65c',
            '#ffff00',
            '#ff6666',
            '#ffc266',
            // documentStyle.getPropertyValue('--pink-400'),
          ],
          label: ''
        },
      ],
    };

    this.options1 = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          display: false // Hide the legend
        }
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        y: {
          type: 'logarithmic', // Use logarithmic scale
          ticks: {
            min: 0, // Set the minimum value
            // stepSize: 2,
            // callback: function(value, index, values) {
            //   if (value === 1) return 0; // Set the first label to 0
            //   const labels = ['500', '1000', '5000', '10000', '50000', '100000']; // Custom labels
            //   return labels[index]; // Return custom labels
            // }
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          // ticks: {
          //   font: {
          //     weight: 700,
          //   },
          //   stepSize: 100,
          //   color: textColorSecondary,
          // },
          grid: {
            display: false,
            // color: this.surfaceBorder,
            // drawBorder: false,
          },
        },
        // y: {
        //   ticks: {
        //     color: textColor,
        //     stepSize: 20,
        //   },
        //   grid: {
        //     color: surfaceBorder,
        //     drawBorder: false
        //   }
        // }

      }
    };

    // this.options1 = {
    //   maintainAspectRatio: false,
    //   aspectRatio: 0.8,
    //   plugins: {
    //     datalabels: {
    //       anchor: 'end',
    //       align: 'end',
    //       color: 'black',
    //       font: {
    //         weight: 'bold'
    //       }
    //     },
    //     legend: {
    //       display: false // Hide the legend
    //     }
    //   },
    //   scales: {
    //     x: {
    //       ticks: {
    //         color: textColor,
    //         font: {
    //           weight: 500
    //         }
    //       },
    //       grid: {
    //         color: surfaceBorder,
    //         drawBorder: false
    //       }
    //     },
    //     y: {
    //       ticks: {
    //         color: textColor
    //       },
    //       grid: {
    //         color: surfaceBorder,
    //         drawBorder: false
    //       }
    //     }

    //   }
    // };
  }

  loadPondBifurcatedData() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.pondBifurcatedData = {
      // labels: [`MI(PDMC) Applications: (${miTotalCount}) `, `Pond/Tank Applications: (${pondTotalCount})`],
      labels: ['Completed', 'Under Process', 'Rejected', 'Incomplete'],
      datasets: [
        {
          data: [this.pondData?.CompletedApps, this.pondData?.UnProcessedApps, this.pondData?.rejectedApp, this.pondData?.InCompleteApps],
          backgroundColor: [
            // documentStyle.getPropertyValue('--green-600'),
            // documentStyle.getPropertyValue('--yellow-600'),
            '#2eb82e',
            '#e6e600',
            '#ff0000',
            '#ff9900',
            // documentStyle.getPropertyValue('--blue-500')
            // documentStyle.getPropertyValue('--pink-500'),
          ],
          hoverBackgroundColor: [
            // documentStyle.getPropertyValue('--green-500'),
            // documentStyle.getPropertyValue('--yellow-500'),
            '#5cd65c',
            '#ffff00',
            '#ff6666',
            '#ffc266',
            // documentStyle.getPropertyValue('--pink-400'),
          ],
          label: ''
        },
      ],
    };


    this.options1 = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          display: false // Hide the legend
        }
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        y: {
          type: 'logarithmic', // Use logarithmic scale
          ticks: {
            min: 0, // Set the minimum value
            // stepSize: 2,
            // callback: function(value, index, values) {
            //   if (value === 1) return 0; // Set the first label to 0
            //   const labels = ['500', '1000', '5000', '10000', '50000', '100000']; // Custom labels
            //   return labels[index]; // Return custom labels
            // }
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          // ticks: {
          //   font: {
          //     weight: 700,
          //   },
          //   stepSize: 100,
          //   color: textColorSecondary,
          // },
          grid: {
            display: false,
            // color: this.surfaceBorder,
            // drawBorder: false,
          },
        },
        // y: {
        //   ticks: {
        //     color: textColor,
        //     stepSize: 20,
        //   },
        //   grid: {
        //     color: surfaceBorder,
        //     drawBorder: false
        //   }
        // }

      }
    };
  }

  onMIChartClick(event) {
    // if (event?.element?.index == 1) {
    //   setTimeout( () => this.miDrillDownData.nativeElement.scrollIntoView({
    //     block: "center",
    //     behavior: "smooth"
    //   }), 400)
    //   this.showMIUnderProcessDetails = true;
    //   this.showPondUnderProcessDetails = false;
    // } else{
    //   this.showMIUnderProcessDetails = false;
    //   this.showPondUnderProcessDetails = false;
    // }

    if (event?.element?.index == 0) {
      setTimeout(() => this.miDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showMICompletedDetails = true;
      this.showMIUnderProcessDetails = false;
      this.showPondUnderProcessDetails = false;
      this.showMIRejectedDetails = false;
      this.showMIIncompletedDetails = false;
    }
    else if (event?.element?.index == 1) {
      setTimeout(() => this.miDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showMIUnderProcessDetails = true;
      this.showPondUnderProcessDetails = false;
      this.showMICompletedDetails = false;
      this.showMIRejectedDetails = false;
      this.showMIIncompletedDetails = false;
    } else if (event?.element?.index == 2) {
      setTimeout(() => this.miDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showMIUnderProcessDetails = false;
      this.showPondUnderProcessDetails = false;
      this.showMICompletedDetails = false;
      this.showMIRejectedDetails = true;
      this.showMIIncompletedDetails = false;
    }
    else if (event?.element?.index == 3) {
      setTimeout(() => this.miDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      this.showMIUnderProcessDetails = false;
      this.showPondUnderProcessDetails = false;
      this.showMICompletedDetails = false;
      this.showMIRejectedDetails = false;
      this.showMIIncompletedDetails = true;
    }
    else {
      this.showMIUnderProcessDetails = false;
      this.showPondUnderProcessDetails = false;

      this.showMICompletedDetails = false;

      this.showMIRejectedDetails = false;

      this.showMIIncompletedDetails = false;
    }
  }

  onPondChartClick(event) {
    if (event?.element?.index == 1) {
      setTimeout( () => this.pondDrillDownData.nativeElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      }), 400)
      // this.showPondUnderProcessDetails = true;
      this.showPondUnderProcessDetails = false;
      this.showMIUnderProcessDetails = false;
    } else {
      this.showPondUnderProcessDetails = false;
      this.showMIUnderProcessDetails = false;
    }
  }

  onPieChartClick(event) {
    if (event?.element?.index == 0) {
      // this.showMITotalDetails = true;
      this.loadMIDistrictWiseData();
      this.loadMIDistrictWiseDashboardData('');
      this.showMIDistrciData = true;
      this.districtWiseHeader = `All districts details`
    } else if (event?.element?.index == 1) {
      // this.showMITotalDetails = false;
    }else{
      // this.showMITotalDetails = false;
    }
  }

  loadMIDistrictWiseData() {
    this.loader.start();
    let sub = this.reportsService
      .getDistrictWiseAllCountDashboardVendor('', 'DistrictWise', this.vendorCode, this.selectedYearForData)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.miDistrictWiseData = data;
            this.loadMIDistrictWiseDataForChart();
            
          } else {
            this.miDistrictWiseData = [];
            this.loadMIDistrictWiseDataForChart();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.miDistrictWiseData = [];
          this.loadMIDistrictWiseDataForChart();

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadMIDistrictWiseDashboardData(districtCode) {
    this.loader.start();
    let sub = this.reportsService
      .getDataForDashboardGraphsVendor(districtCode,this.userType,this.vendorCode, '')
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.miDistrictWiseDashboardData = data;
            this.loadPieDataDistrictWise();
          } else {
            this.miDistrictWiseDashboardData = [];
            this.loadPieDataDistrictWise();

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Available',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.miDistrictWiseDashboardData = [];
          this.loadPieDataDistrictWise();

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });
  }

  loadMIDistrictWiseDataForChart() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    const districts = this.miDistrictWiseData.map(item => item.District);
    const totalApp = this.miDistrictWiseData.map(item => item.totalApp);

    
    this.miDistrictWiseDataForChart = {
      labels: districts,
      datasets: [
        {
          data: totalApp,
          backgroundColor: [
            // documentStyle.getPropertyValue('--green-600'),
            // documentStyle.getPropertyValue('--yellow-600'),
            // documentStyle.getPropertyValue('--blue-500')
            // documentStyle.getPropertyValue('--pink-500'),
            // '#2eb82e',
            // '#e6e600',
            // '#ff0000',
            // '#ff9900',
            '#dd4b39',
            'rgb(0, 102, 204)',
            'rgb(153, 153, 102)',
            'rgb(191, 128, 64)',
            'rgb(51, 153, 102)',
            '#00bcd4'
          ],
          hoverBackgroundColor: [
            '#dd4b39',
            'rgb(0, 102, 204)',
            'rgb(153, 153, 102)',
            'rgb(191, 128, 64)',
            'rgb(51, 153, 102)',
            '#00bcd4'
          ],
          label: ''
        },
      ],
    };

    this.optionsMIDW = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          display: false // Hide the legend
        }
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        y: {
          type: 'logarithmic', // Use logarithmic scale
          ticks: {
            min: 0, // Set the minimum value
            // stepSize: 2,
            // callback: function(value, index, values) {
            //   if (value === 1) return 0; // Set the first label to 0
            //   const labels = ['500', '1000', '5000', '10000', '50000', '100000']; // Custom labels
            //   return labels[index]; // Return custom labels
            // }
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          // ticks: {
          //   font: {
          //     weight: 700,
          //   },
          //   stepSize: 100,
          //   color: textColorSecondary,
          // },
          grid: {
            display: false,
            // color: this.surfaceBorder,
            // drawBorder: false,
          },
        },
        // y: {
        //   ticks: {
        //     color: textColor,
        //     stepSize: 20,
        //   },
        //   grid: {
        //     color: surfaceBorder,
        //     drawBorder: false
        //   }
        // }

      }
    };
  }

  onDistrictChartClick(event){
    let districtCode: any = '';
    let selectedDistrict: any = 'All District';
    let indexVal = event?.element?.index;
    if(indexVal == 0){
      districtCode = '01'; //Ambala
      selectedDistrict = 'Ambala';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 1){
      districtCode = '02'; // Bhiwani
      selectedDistrict = 'Bhiwani';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 3){
      districtCode = '03'; // Faridabad
      selectedDistrict = 'Faridabad';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 4){
      districtCode = '04'; // Fatehabad
      selectedDistrict = 'Fatehabad';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 5){
      districtCode = '05'; // Gurugram
      selectedDistrict = 'Gurugram';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 6){
      districtCode = '06'; // Hissar
      selectedDistrict = 'Hissar';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 7){
      districtCode = '07'; // Jhajjar
      selectedDistrict = 'Jhajjar';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 8){
      districtCode = '08'; // Jind
      selectedDistrict = 'Jind';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 9){
      districtCode = '09'; // Kaithal
      selectedDistrict = 'Kaithal';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 10){
      districtCode = '10'; // Karnal
      selectedDistrict = 'Karnal';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 11){
      districtCode = '11'; // Kurukshetra
      selectedDistrict = 'Kurukshetra';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 12){
      districtCode = '12'; // Mahindergarh
      selectedDistrict = 'Mahindergarh';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 15){
      districtCode = '13'; // Panchkula
      selectedDistrict = 'Panchkula';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 16){
      districtCode = '14'; // Panipat
      selectedDistrict = 'Panipat';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 17){
      districtCode = '15'; // Rewari
      selectedDistrict = 'Rewari';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 18){
      districtCode = '16'; // Rohtak
      selectedDistrict = 'Rohtak';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 19){
      districtCode = '17'; // Sirsa
      selectedDistrict = 'Sirsa';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 20){
      districtCode = '18'; // Sonipat
      selectedDistrict = 'Sonipat';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 21){
      districtCode = '19'; // Yamunanagar
      selectedDistrict = 'Yamunanagar';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 13){
      districtCode = '20'; // Nuh
      selectedDistrict = 'Nuh';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 14){
      districtCode = '21'; // Palwal
      selectedDistrict = 'Palwal';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else if(indexVal == 2){
      districtCode = '22'; // Charkhi Dadri
      selectedDistrict = 'Charkhi Dadri';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }else{
      selectedDistrict = 'all district';
      this.loadMIDistrictWiseDashboardData(districtCode);
    }

    setTimeout( () => this.miDistrictWiseDataCard.nativeElement.scrollIntoView({
      block: "end",
      behavior: "smooth"
    }), 400)

    this.districtWiseHeader = `District: ${selectedDistrict}`
  }

  loadPieDataDistrictWise() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    // user wise
    const atalUserData = this.miDistrictWiseDashboardData[0][0];
    const normalUserData = this.miDistrictWiseDashboardData[1][0];

    // caste wise
    const casteWiseData = this.miDistrictWiseDashboardData[2];

    // component wise
    const componentWiseData = this.miDistrictWiseDashboardData[3];

    // line graph for yearWise area
    const yearWiseArea = this.miDistrictWiseDashboardData[4];

    const completedAppReport = this.miDistrictWiseDashboardData[5][0];

    this.totalSubsidyDisbursed = completedAppReport?.paymentDoneCAO/10000000;
    this.totalAppCompleted = completedAppReport?.Payment_Done_Application_By_CAO;
    this.totalMIAreaCompleted = completedAppReport?.Payment_done_MI_Area;

    // this.targetTotalSubsidyDisbursed = completedAppReport?.paymentDoneCAO;
    // this.targetTotalAppCompleted = completedAppReport?.Payment_Done_Application_By_CAO;
    // this.targetTotalMIAreaCompleted = completedAppReport?.totalMIAreaCompleted;

    if(this.showMIDistrciData){
      this.animateCounter('totalSubsidyDisbursed', this.totalSubsidyDisbursed);
      this.animateCounter('totalAppCompleted', this.totalAppCompleted);
      this.animateCounter('totalMIAreaCompleted', this.totalMIAreaCompleted);
    }

    this.subsidyDataForChart = {
      labels: [`Application Completed`, `Application Pending`],
      datasets: [
        {
          data: [atalUserData?.Payment_Done_Application_By_CAO + normalUserData?.Payment_Done_Application_By_CAO, 
            (atalUserData?.UnProcessedApps)+(normalUserData?.UnProcessedApps)
          ],
          backgroundColor: [
            // documentStyle.getPropertyValue('--green-500'),
            // documentStyle.getPropertyValue('--bluegray-500'),
            // documentStyle.getPropertyValue('--cyan-700'),
            // documentStyle.getPropertyValue('--pink-600'),
            '#09b328',
            '#e8c123'
          ],
          hoverBackgroundColor: [
            // documentStyle.getPropertyValue('--green-400'),
            // documentStyle.getPropertyValue('--bluegray-500'),
            '#09b328',
            '#e8c123'
          ],
          borderWidth: 2
        },
      ],
    };

    this.subsidyAreaDataForChart  = {
      labels: [`Disbursed Area`, `Pending Area`],
      datasets: [
        {
          data: [atalUserData?.Payment_done_MI_Area + normalUserData?.Payment_done_MI_Area, 
            (atalUserData?.UnProcessedAppsArea)+(normalUserData?.UnProcessedAppsArea)],
          backgroundColor: [
            // documentStyle.getPropertyValue('--green-500'),
            // documentStyle.getPropertyValue('--bluegray-500'),
            // documentStyle.getPropertyValue('--cyan-700'),
            // documentStyle.getPropertyValue('--pink-600'),
            '#b300b3',
            '#0000e6'
          ],
          hoverBackgroundColor: [
            // documentStyle.getPropertyValue('--bluegray-500'),
            // documentStyle.getPropertyValue('--cyan-700'),
            '#b300b3',
            '#0000e6'
          ],
          borderWidth: 2
        },
      ],
    };

    this.subsidyAmountDataForChart  = {
      labels: [`Disbursed Amount`, `Pending Amount`],
      datasets: [
        {
          data: [atalUserData?.Payment_done_MI_Area + normalUserData?.Payment_done_MI_Area, atalUserData?.pending + normalUserData?.pending],
          backgroundColor: [
            // documentStyle.getPropertyValue('--green-500'),
            // documentStyle.getPropertyValue('--bluegray-500'),
            // documentStyle.getPropertyValue('--cyan-700'),
            // documentStyle.getPropertyValue('--pink-600'),
            '#8c1aff',
            '#e67300'
          ],
          hoverBackgroundColor: [
            // documentStyle.getPropertyValue('--bluegray-500'),
            // documentStyle.getPropertyValue('--cyan-700'),
            '#8c1aff',
            '#e67300'
          ],
          borderWidth: 2
        },
      ],
    };

    this.casteDataForChart = {
      labels: [`Gen`, `BC`, `SC/ST`],
      datasets: [
        {
          data: [casteWiseData[1]?.totalApp, casteWiseData[2]?.totalApp, casteWiseData[0]?.totalApp],
          backgroundColor: [
            // documentStyle.getPropertyValue('--cyan-700'),
            // documentStyle.getPropertyValue('--pink-600'),
            '#37b4c4',
            '#0f48f5',
            '#b90cf2'
          ],
          hoverBackgroundColor: [
            '#37b4c4',
            '#0f48f5',
            '#b90cf2'
          ],
          borderWidth: 2
        },
      ],
    };

    this.appTypeDataForChart = {
      labels: [`ABY`, `Normal`],
      datasets: [
        {
          data: [atalUserData?.totalApp, normalUserData?.totalApp],
          backgroundColor: [
            documentStyle.getPropertyValue('--cyan-700'),
            documentStyle.getPropertyValue('--pink-600'),
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--cyan-700'),
            documentStyle.getPropertyValue('--pink-600'),
          ],
          borderWidth: 2
        },
      ],
    };

    this.componentDataForChart = {
      labels: [`Portable`,  `Mini`, `Drip` ],
      datasets: [
        {
          data: [componentWiseData[0]?.TotalApp, componentWiseData[1]?.TotalApp, componentWiseData[2]?.TotalApp],
          backgroundColor: [
            // documentStyle.getPropertyValue('--cyan-700'),
            // documentStyle.getPropertyValue('--pink-600'),
            '#990073',
            '#6600ff',
            '#00b33c'
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--cyan-700'),
            documentStyle.getPropertyValue('--pink-600'),
          ],
          borderWidth: 2
        },
      ],
    };

    let yearName = yearWiseArea.map(item => item.FinYear);
    let yearVal = yearWiseArea.map(item => item.TotalArea);

    this.yearWiseDataForChart = {
      labels: yearName,
      datasets: [
        {
          data: yearVal,
          backgroundColor: [
            // documentStyle.getPropertyValue('--cyan-700'),
            // documentStyle.getPropertyValue('--pink-600'),
            '#990073',
            '#6600ff',
            '#00b33c'
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--cyan-700'),
            documentStyle.getPropertyValue('--pink-600'),
          ],
          fill: false,
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          tension: 0.4
        },
      ],
    };

    this.optionsLine = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {
          display: false // Hide the legend
        },
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: true
          }
        },
        y: {
          type: 'logarithmic', // Use logarithmic scale
          ticks: {
            min: 0, // Set the minimum value
            // stepSize: 2,
            // callback: function(value, index, values) {
            //   if (value === 1) return 0; // Set the first label to 0
            //   const labels = ['500', '1000', '5000', '10000', '50000', '100000']; // Custom labels
            //   return labels[index]; // Return custom labels
            // }
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          // ticks: {
          //   font: {
          //     weight: 700,
          //   },
          //   stepSize: 100,
          //   color: textColorSecondary,
          // },
          grid: {
            display: false,
            // color: this.surfaceBorder,
            // drawBorder: false,
          },
        },
      },
  };

    this.options2 = {
      plugins: {
        datalabels: {
          anchor: 'center',
          align: 'end',
          color: 'white',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          labels: {
            usePointStyle: true,
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
        },
      },
    };
  }

  viewMIConsolidatedReport(){
    if(this.userId == 'admin'){
      this.router.navigate(['admin', 'report', 'mi-total-app-report']);
    }
    else if(this.userId == 'cao'){
      this.router.navigate(['cao', 'report', 'mi-total-app-report']);
    }
    else if(this.userId == 'Vendor'){
      this.router.navigate(['vendor', 'report', 'mi-total-app-report']);
    }
    else{
      this.router.navigate(['department', 'report', 'mi-total-app-report']);
    }
  }

  viewMIConsolidatedDetails() {
    let userId = this.userId;

    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const isVendorLogin = loginDetails.get('isVendor') ? loginDetails.get('isVendor') : null;

    if(isVendorLogin == '1'){
      userId = 'vendor';
    }
    if (userId == 'admin') {
      // this.router.navigate(['admin', 'report', 'mi-consolidated-details']);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['admin', 'report', 'mi-consolidated-details']));
      window.open(url, '_blank');
    }
    else if (userId == 'cao') {
      // this.router.navigate(['cao', 'report', 'mi-consolidated-details']);

      const url = this.router.serializeUrl(
        this.router.createUrlTree(['cao', 'report', 'mi-consolidated-details']));
      window.open(url, '_blank');
    }
    else if(userId == 'vendor'){
      const url = this.router.serializeUrl(
      this.router.createUrlTree(['vendor', 'report', 'mi-consolidated-details']));
      window.open(url, '_blank');
    }
    else {
      // this.router.navigate(['department', 'report', 'mi-consolidated-details']);
      const url = this.router.serializeUrl(
      this.router.createUrlTree(['department', 'report', 'mi-consolidated-details']));
      window.open(url, '_blank');
    }
  }

}
